import edap from '../edap';
import InviteModal from './invite-modal-provider';
import InvalidInviteModal from './invalid-invite-modal';
import queryString from 'query-string';
import React, {Component} from 'react';
import {Redirect, withRouter} from 'react-router-dom';
import TestExposureOnce from '../../../abacus/test-exposure-once';
import {HA_PULSE_INVITE_ACCEPT_MODAL_TEST} from '../../../abacus/experiments';

export const testExposureInviteModal = new TestExposureOnce(HA_PULSE_INVITE_ACCEPT_MODAL_TEST);

export function getInviteId(params = {}) {
    return params.invalid || null;
}

export function getParams(location = {}) {
    const {search} = location;
    return search ? queryString.parse(search) : {};
}

export function isNewModal(params = {}) {
    return !!params.modal;
}

export function getModalInviteId(params = {}) {
    return params.modal || null;
}

export function isInviteAccept(params = {}) {
    return !!params.invite;
}

export function isInviteInvalid(params = {}) {
    return !!params.invalid;
}

export class InviteAccept extends Component {
    static defaultProps = {
        boardId: null,
        location: {}
    };

    constructor(props) {
        super(props);
        this.state = {
            inviteId: null,
            isAccept: false,
            isInvalid: false,
            isNewInviteModal: false,
            modalInviteId: null
        };
    }

    componentDidMount() {
        this.validateInvite();
    }

    shouldComponentUpdate(_, nextState) {
        const {isAccept, isInvalid, isNewInviteModal} = nextState;
        const state = this.state;
        return (
            isAccept !== state.isAccept || isInvalid !== state.isInvalid || isNewInviteModal !== state.isNewInviteModal
        );
    }

    validateInvite = () => {
        const {boardId, endDate, location, startDate} = this.props;
        const params = getParams(location);
        const isAccept = isInviteAccept(params);
        const isInvalid = isInviteInvalid(params);
        const isNewInviteModal = isNewModal(params);
        const inviteId = isInvalid ? getInviteId(params) : null;
        const modalInviteId = getModalInviteId(params);
        this.setState({inviteId, isAccept, isInvalid, isNewInviteModal, modalInviteId});

        if (isAccept) {
            edap.acceptInvite(boardId, endDate, startDate);
        }

        if (isInvalid) {
            edap.invalidInvite(inviteId);
        }

        if (isInvalid || isAccept) {
            testExposureInviteModal.trigger(HA_PULSE_INVITE_ACCEPT_MODAL_TEST);
        }
    };

    render() {
        const {location} = this.props;
        const {inviteId, isAccept, isInvalid, isNewInviteModal, modalInviteId} = this.state;

        if (isAccept) {
            // we've run through the gauntlet of checks and the user is going to the newly invited tripboard
            return <Redirect to={location.pathname} />;
        }
        if (isInvalid) {
            // we are not in the invite modal test, and the invite is invalid for some reason
            return <InvalidInviteModal inviteId={inviteId} />;
        }
        if (isNewInviteModal) {
            // we are in the new modal test and we are starting the process of checking for expired tripboards and unlogged in users
            return <InviteModal invitationId={modalInviteId} />;
        }
        return null;
    }
}

export default withRouter(InviteAccept);



// WEBPACK FOOTER //
// ./src/universal/tripboard/collaborate/components/invite-accept.js